import * as React from "react";
import {BasicEventCard} from "./BasicEventCard";
import { EventShortProps } from "../../types";

export const EmployerEventCard = ({ event }: { event: EventShortProps }) => {
  return(
    <BasicEventCard event={event}/>
  )
}